import type { FeatureZoomOverride } from "./featureZoomOverrideTypes";

// Per-part zoom overrides for visualizerType "Bathroom" — see the shape/unit docs in
// ../featureGroupZoomDefaults.ts (getFeatureZoomOverride). Bulk-ported (2026-08-15) from
// scss/bv/responsive-canvas-bathroom.scss's per-part `scale(X)` values. Seeded even though
// Bathroom isn't on the docked canvas yet, so it's ready if/when that type moves over.
export function getBathroomFeatureZoomOverride(partId: string): FeatureZoomOverride | undefined {
  switch (partId) {
    case "accent_wall":
    case "pony_wall":
    case "pony_wall_cap":
    case "pony_wall_glass":
    case "shower_body":
    case "shower_door":
    case "shower_door_handle":
    case "shower_glass":
    case "shower_interior_wall":
    case "shower_interior_wall_accent":
    case "vanity_backsplash":
    case "vanity_cabinet":
    case "vanity_countertop":
    case "vanity_faucet":
    case "vanity_mirror":
    case "vanity_sink":
    case "wall_c":
    case "wall_configuration":
      return { scale: 1.3 };
    case "bathtub_liner":
    case "jetted_tub":
    case "replacement_tub":
    case "shower_floor":
    case "shower_pan_combo":
    case "threshold":
    case "walk_in_tub":
      return { scale: 1.4 };
    case "corner_caddie":
    case "grab_bar":
    case "large_corner_seat":
    case "shower_fixture":
    case "shower_head":
    case "shower_seats":
    case "toilet":
    case "window":
      return { scale: 1.5 };
    case "large_corner_caddie":
    case "left_shower_wall":
    case "right_shower_wall":
      return { scale: 1.2 };
    case "small_corner_shelf":
    case "soap_dish":
      return { scale: 1.7 };
    default:
      return undefined;
  }
}
